module.exports = __webpack_public_path__ + "img/paris5.3c93629f.jpeg";